<template>
  <div class="response-level proto-card">
    <div class="level-head">
      <strong class="level-title">{{ levelTitle }}</strong>
      <div class="switch-row">
        <span>启用本级别</span>
        <el-switch
          v-model="form.levelEnabled"
          :active-value="1"
          :inactive-value="0"
        />
      </div>
    </div>
    <div class="form-field">
      <label class="field-label">启动条件</label>
      <el-input
        v-model="form.triggerConditions"
        type="textarea"
        :rows="3"
        maxlength="1000"
        show-word-limit
        placeholder="达到何种情形时启动本级响应"
      />
    </div>
    <div class="form-field">
      <label class="field-label">应急处理方案</label>
      <el-input
        v-model="form.actionPlan"
        type="textarea"
        :rows="3"
        maxlength="1000"
        show-word-limit
        placeholder="本级响应下的总体处置流程与要点"
      />
    </div>
    <el-tabs v-model="phaseTab" class="phase-sub-tabs">
      <el-tab-pane label="事前" name="1">
        <phase-groups-table v-model="phase1" :user-options="userOptions" />
      </el-tab-pane>
      <el-tab-pane label="事中" name="2">
        <phase-groups-table v-model="phase2" :user-options="userOptions" />
      </el-tab-pane>
      <el-tab-pane label="事后" name="3">
        <phase-groups-table v-model="phase3" :user-options="userOptions" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getUserList } from '../../api'
import PhaseGroupsTable from './third-layer-form/phase-groups-table.vue'

export default {
  name: 'ResponsesTo',
  components: { PhaseGroupsTable },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    levelTitle: {
      type: String,
      default: '应急响应'
    },
    responseLevel: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      phaseTab: '1',
      form: {
        triggerConditions: '',
        actionPlan: '',
        levelEnabled: 1
      },
      phase1: [],
      phase2: [],
      phase3: [],
      userOptions: []
    }
  },
  watch: {
    info: {
      deep: true,
      immediate: true,
      handler () {
        this.initFromInfo()
      }
    }
  },
  mounted () {
    this.loadUsers()
  },
  methods: {
    loadUsers () {
      getUserList().then(({ data }) => {
        const list = Array.isArray(data) ? data : (data && data.data) ? data.data : []
        this.userOptions = list
      }).catch(() => {
        this.userOptions = []
      })
    },
    normalizeApiGroup (g) {
      let mids = []
      if (Array.isArray(g.groupMemberIds)) {
        mids = [...g.groupMemberIds]
      } else if (typeof g.groupMemberIds === 'string' && g.groupMemberIds) {
        mids = g.groupMemberIds.split(',').map(s => s.trim()).filter(Boolean).map(s => {
          const n = Number(s)
          return Number.isNaN(n) ? s : n
        })
      }
      return {
        groupName: g.groupName || '',
        groupLeaderId: g.groupLeaderId,
        groupLeaderName: g.groupLeaderName || '',
        groupMemberIds: g.groupMemberIds || '',
        groupMemberNames: g.groupMemberNames || '',
        groupDuties: g.groupDuties || '',
        timeoutMinutes: g.timeoutMinutes != null && g.timeoutMinutes !== '' ? String(g.timeoutMinutes) : undefined,
        executionOrder: g.executionOrder,
        _memberIds: mids
      }
    },
    initFromInfo () {
      const info = this.info || {}
      const g = info.groups || []
      this.form = {
        triggerConditions: info.triggerConditions || '',
        actionPlan: info.actionPlan || '',
        levelEnabled: 1
      }
      const byPhase = ph => g
        .filter(x => String(x.responsePhase) === String(ph))
        .map(x => this.normalizeApiGroup(x))
      this.phase1 = byPhase('1')
      this.phase2 = byPhase('2')
      this.phase3 = byPhase('3')
    },
    serializePhase (list, phase) {
      if (!list || !list.length) return []
      return list.map((row, index) => {
        let timeout = row.timeoutMinutes
        if (timeout === '' || timeout === undefined) {
          timeout = null
        } else {
          const n = parseInt(String(timeout), 10)
          timeout = Number.isNaN(n) ? null : n
        }
        return {
          groupName: row.groupName,
          groupLeaderId: row.groupLeaderId,
          groupLeaderName: row.groupLeaderName || '',
          groupMemberIds: typeof row.groupMemberIds === 'string'
            ? row.groupMemberIds
            : (row._memberIds && row._memberIds.length ? row._memberIds.join(',') : ''),
          groupMemberNames: row.groupMemberNames || '',
          groupDuties: row.groupDuties,
          timeoutMinutes: timeout,
          executionOrder: index + 1,
          responsePhase: String(phase)
        }
      })
    },
    echoData () {
      const groups = [
        ...this.serializePhase(this.phase1, '1'),
        ...this.serializePhase(this.phase2, '2'),
        ...this.serializePhase(this.phase3, '3')
      ]
      return {
        responseLevel: this.responseLevel,
        triggerConditions: this.form.triggerConditions,
        actionPlan: this.form.actionPlan,
        groups
      }
    }
  }
}
</script>

<style scoped lang="scss">
.response-level {
  margin-bottom: 12px;
  padding: 16px 18px 18px;
  background: #fbfdff;
  border: 1px solid #e6edf6;
  border-radius: 8px;
}
.level-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.level-title {
  font-size: 15px;
  color: #1f2d3d;
}
.switch-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #475569;
}
.form-field {
  margin-bottom: 14px;
}
.field-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 6px;
}
.phase-sub-tabs {
  margin-top: 6px;
  padding-top: 2px;
}
::v-deep .phase-sub-tabs > .el-tabs__header {
  margin-bottom: 12px;
}
::v-deep .phase-sub-tabs .el-tabs__item {
  font-size: 13px;
  color: #64748b;
  height: 32px;
  line-height: 32px;
}
::v-deep .phase-sub-tabs .el-tabs__item.is-active {
  color: #409eff;
  font-weight: 600;
}
::v-deep .phase-sub-tabs .el-tabs__nav-wrap::after {
  height: 1px;
  background: #e9eef3;
}
::v-deep .phase-sub-tabs .el-tabs__active-bar {
  background-color: #409eff;
}
</style>
